// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"da9997e7","256":"47881269"}[chunkId] + ".chunk.js";
};